/* RK Email capture — posts [data-rk-email-capture] forms to the recipekit-signup Worker.
   Plain script (no module) so it works on every template. Safe to load more than once.

   Markup: snippets/rk-email-capture-form.liquid.
   - source: the form's placement (article-inline, article-end, slide-in, footer,
     tools-hub, ...). Always the placement, never the utm_source: the daily funnel
     report counts signups by source, so a tagged visit must not hide where the
     form sat. The Worker slugs it into the Bento tag source:<value>.
   - page_url: the full URL. The Worker keeps origin + path only.
   - utm_*: sent as separate fields. The Worker logs them next to the source.
   - On success the form dispatches `rk:email-signup` on document with
     { magnet, source }. The blog slide-in listens so it can close for good.
   - Forms with data-download: a successful signup hides the form and reveals the
     download panel. Every form for the same magnet on the page switches together,
     and a return visit from the same browser opens straight on the download. */
(function () {
  if (window.__rkEmailCapture) return;
  window.__rkEmailCapture = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var STORE_PREFIX = 'rk-signup:';

  function track(name, data) {
    try {
      if (window.umami && typeof window.umami.track === 'function') window.umami.track(name, data);
    } catch (e) {}
  }

  function utm() {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach(function (k) {
        var v = params.get(k);
        if (v) out[k] = v.slice(0, 100);
      });
    } catch (e) {}
    return out;
  }

  function remember(magnet) {
    if (!magnet) return;
    try {
      window.localStorage.setItem(STORE_PREFIX + magnet, String(Date.now()));
    } catch (e) {}
  }

  function remembered(magnet) {
    if (!magnet) return false;
    try {
      return Boolean(window.localStorage.getItem(STORE_PREFIX + magnet));
    } catch (e) {
      return false;
    }
  }

  function setMessage(form, state, text) {
    var msg = form.parentNode.querySelector('.rk-email-capture__message');
    if (!msg) return;
    msg.dataset.state = state;
    msg.textContent = text;
    msg.hidden = false;
  }

  function clearMessage(form) {
    var msg = form.parentNode.querySelector('.rk-email-capture__message');
    if (msg) msg.hidden = true;
  }

  /* Hide the form and show the download panel next to it. */
  function reveal(form, returning, focus) {
    var done = form.parentNode.querySelector('[data-rk-email-capture-done]');
    if (!done) return false;
    form.classList.add('is-done');
    clearMessage(form);
    var fresh = done.querySelector('[data-new]');
    var back = done.querySelector('[data-returning]');
    if (fresh) fresh.hidden = Boolean(returning);
    if (back) back.hidden = !returning;
    done.hidden = false;
    if (focus) done.focus({ preventScroll: true });
    return true;
  }

  function revealAll(magnet, returning, source) {
    var forms = document.querySelectorAll('[data-rk-email-capture][data-download]');
    for (var i = 0; i < forms.length; i++) {
      if ((forms[i].dataset.magnet || '') === magnet) reveal(forms[i], returning, forms[i] === source);
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-rk-email-capture]')) return;
    event.preventDefault();

    var ds = form.dataset;
    var emailInput = form.elements.email;
    var email = (emailInput.value || '').trim();
    var btn = form.querySelector('button[type=submit]');
    var label = btn && btn.querySelector('[data-label]');

    if (!EMAIL_RE.test(email)) {
      emailInput.setAttribute('aria-invalid', 'true');
      setMessage(form, 'error', ds.msgInvalid);
      emailInput.focus();
      return;
    }
    emailInput.removeAttribute('aria-invalid');

    if (!ds.workerUrl) {
      setMessage(form, 'error', ds.msgError);
      return;
    }

    var tags = utm();
    var payload = {
      email: email,
      first_name: form.elements.first_name ? form.elements.first_name.value.trim() : '',
      source: ds.source || '',
      magnet: ds.magnet || '',
      page_url: window.location.href,
      website: form.elements.website ? form.elements.website.value : '',
    };
    UTM_KEYS.forEach(function (k) {
      if (tags[k]) payload[k] = tags[k];
    });

    var original = label ? label.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    if (label && ds.msgBusy) label.textContent = ds.msgBusy;

    fetch(ds.workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            return { ok: res.ok && body.ok, body: body };
          });
      })
      .then(function (r) {
        if (r.ok) {
          // The Worker upserts, so an email that is already subscribed also lands here.
          remember(payload.magnet);
          track('email-capture-success', { source: payload.source, magnet: payload.magnet });
          try {
            document.dispatchEvent(
              new CustomEvent('rk:email-signup', { detail: { magnet: payload.magnet, source: payload.source } })
            );
          } catch (e) {}
          form.reset();
          if (ds.download && payload.magnet) {
            revealAll(payload.magnet, false, form);
          } else {
            form.classList.add('is-done');
            setMessage(form, 'success', ds.msgSuccess);
          }
        } else {
          setMessage(form, 'error', r.body && r.body.error === 'invalid_email' ? ds.msgInvalid : ds.msgError);
        }
      })
      .catch(function () {
        setMessage(form, 'error', ds.msgError);
      })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
        if (label) label.textContent = original;
      });
  }

  function restore() {
    var forms = document.querySelectorAll('[data-rk-email-capture][data-download]');
    for (var i = 0; i < forms.length; i++) {
      var magnet = forms[i].dataset.magnet || '';
      if (remembered(magnet)) reveal(forms[i], true, false);
    }
  }

  document.addEventListener('submit', onSubmit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
  else restore();
})();
